import type { ProductBrand } from "@/types/products/api-types/product-brand-types";

export function getProductBrandFormValues(brand?: ProductBrand) {
  return {
    name: brand?.name ?? "",
  };
}
